module.exports = __webpack_public_path__ + "media/images/lp/cta_btn-f34f94d5915fe880bb86d2cc62355374.webp";